import AppRoutes from "./routes/AppRoutes";
import Navbar from "./pages/widgets/navbar";

function App() {
  return (
    <>
      <Navbar/>
      <AppRoutes />
    </>
  );
}

export default App;